export default "__VITE_ASSET__Co7B7hyr__"